wishlistPageInit = () => {
  new Vue({
    delimiters: ['${', '}'],
    el: '#app',
    vuetify: new Vuetify(),
    name: 'PageWishlist',
    filters: {
      toUSD: (amount) => {
        return window.Shopify.formatMoney(amount, window.theme.moneyFormat || '${{amount}}')
      }
    },
    data() {
      return {
        auth: false,
        data: [],
        copyWishlistText: 'Copy Url',
        createName: '',
        createMessage: 'Must provide a list name',
        deleteMessage: '',
        duplicateMessage: '',
        duplicateName: '',
        dropdown: false,
        lists: [],
        loading: true,
        modal: {
          auth: false,
          create: false,
          delete: false,
          duplicate: false,
          notify: false,
          share: false
        },
        notify: {
          message: '',
          product: null,
          variant: {
            id: null,
            title: null
          }
        },
        selected: '',
        shareMessage: '',
        shareMode: false,
        shareURLactive: '',
        shareURLs: [],
        subscribe: {
          display: true,
          selected: false,
          listId: window.theme.baseCurrency === 'USD' ? 'PXfTGi' : 'PS9Tkx'
        },
        user: {
          fname: '',
          from: '',
          lname: '',
          message: '',
          name: '',
          to: ''
        }
      }
    },
    computed: {
      products: function() {
        this.lists.forEach((list) => {
          const sortOrder = []
          list.listcontents.forEach((item) => {
            sortOrder.push(item.empi)
          })
          this.data.some((data) => {
            if (data[0] && data[0].swym.lid == list.lid) {
              data.sort((a, b) => {
                return sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id)
              })
              return true
            }
          })
        })
        return this.data
      },
      shareURL: function() {
        const activeShare = this.shareURLs.find(share => share.lid === this.shareURLactive)
        if (activeShare) {
          return activeShare.url
        }

        return false
      },
      wishlists: function() {
        return this.lists
      }
    },
    methods: {
      addAllToBag() {
        const items = this.$refs.item
        const variants = []

        items.forEach((item) => {
          const select = item.querySelector('select')
          const selected = select.options[select.selectedIndex]
          const available = selected.getAttribute('data-available')

          if (available === 'true') {
            variants.push(selected.value)
          }
        })

        // Asynchronous for Shopify
        const addItem = () => {
          if (variants.length) {
            const variant = variants.shift()
            const data = {}

            data.id = variant
            data.quantity = 1

            const body = JSON.stringify(data);

            fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
              .then((response) => {
                return response.json();
              })
              .then((res) => {
                document.dispatchEvent(new CustomEvent('cart.addItem', { detail: res }));
                addItem()
              })
              .catch(error => {
                document.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
                const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
                if (!errors) return;
                errors.textContent = window.cartStrings.error;
              });
          } else {
            loadMinicart();
            document.querySelector('cart-drawer').open();
            headerCartCount();
          }
        }

        addItem()
      },
      addToBag(index) {
        const select = document.querySelector(`[data-size-select="${index}"]`) // Because $refs is too damn slow
        const id = select.value

        window.addToBag({
          id: id,
          quantity: 1
        })
      },
      authCheck() {
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = []
        }

        window.SwymCallbacks.push(() => {
          window._swat.authCheck((response) => {
            if (response.email) {
              this.user.from = response.email
            }

            if (response.regn.hasOwnProperty('userinfo')) {
              if (response.regn.userinfo.fname && response.regn.userinfo.lname) {
                this.user.fname = response.regn.userinfo.fname
                this.user.lname = response.regn.userinfo.lname
                this.user.name = `${response.regn.userinfo.fname} ${response.regn.userinfo.lname}`
              }
            }

            this.auth = response.authn
          })
        })
      },
      authLogOut() {
        const successCallback = () => {}
        const errorFn = () => {}
        window._swat.disconnectShopperContext(successCallback, errorFn)
      },
      copyURL(url) {
        navigator.clipboard.writeText(url).then(() => {
          const originalText = this.copyWishlistText
          this.copyWishlistText = 'Copied!'
          setTimeout(() => {
            this.copyWishlistText = originalText
          }, 1000)
        }, () => {
          window.open(url, '_blank')
        })
      },
      createList() {
        const listExists = Object.values(this.lists).some(list => list.lname.toLowerCase() === this.createName.toLowerCase())

        if (listExists) {
          this.createMessage = `The wishlist "${this.createName}" already exists`
          return false
        }

        window._swat.createList(
          {
            'lname': this.createName
          },
          (response) => {
            if (response && response.hasOwnProperty('msg')) {
              this.createMessage = response.msg
            }

            window.SwymCallbacks.push(() => {
              this.selected = ''
              this.modal.create = false
              this.createName = ''
              this.createMessage = 'Must provide a list name'
              this.lists = []

              this.$nextTick(() => {
                this.fetchWishlists()
              })
            })
          },
          (err) => {
            this.createMessage = err
          }
        )
      },
      createValidateInput() {
        const listExists = Object.values(this.lists).some(list => list.lname.toLowerCase() === this.createName.toLowerCase())

        if (listExists) {
          this.createMessage = `The wishlist "${this.createName}" already exists`
          return false
        } else if (this.createName === '') {
          this.createMessage = 'Must provide a list name'
          return false
        } else if (this.createName.length < 3) {
          this.createMessage = 'Name must be longer than 3 characters'
          return false
        } else {
          this.createMessage = ''
          return true
        }
      },
      duplicateList() {
        const listExists = Object.values(this.lists).some(list => list.lname.toLowerCase() === this.duplicateName.toLowerCase())

        if (listExists) {
          this.duplicateMessage = `The wishlist "${this.duplicateName}" already exists`
          return false
        }

        let duplicateLty = Object.values(this.lists).find(list => list.lid === this.selected).lty
        const listDef = {
          lname: this.duplicateName,
          lty: duplicateLty,
          fromlid: this.selected,
          lnote: '',
          lprops: {}
        }

        window._swat.createList(listDef, (response) => {
          const listId = response.lid

          window.SwymCallbacks.push(() => {
            this.selected = listId
            this.modal.duplicate = false
            this.duplicateName = ''
            this.lists = []

            this.$nextTick(() => {
              this.fetchWishlists()
            })
          })
        },
        (err) => {
          console.log(err)
        })
      },
      events() {
        document.addEventListener('click', (e) => {
          if (!e.target.matches('[data-wishlist-options]')) {
            this.dropdown = false
          }
        }, false)
      },
      fetchSize(options, variant) {
        let optionsIndex = null

        options.forEach((option, i) => {
          if (option.name.toLowerCase() === 'size') optionsIndex = option.position
        })

        if (optionsIndex === null) return null
        return variant[`option${optionsIndex}`]
      },
      fetchWishlists() {
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = []
        }

        window.SwymCallbacks.push(() => {
          window._swat.fetchLists({
            callbackFn: (response) => {
              if (response.length) {
                let listIds = []
                this.lists = []
                this.data = []

                // Exclude duplicate list ids
                response.forEach((item, i) => {
                  if (listIds.includes(item.lid)) return
                  this.lists.push(item)
                  listIds.push(item.lid)
                })

                this.$nextTick(() => {
                  this.loading = false
                })

                this.lists.forEach((item, i) => {
                  // Products
                  const productsArray = []

                  window._swat.fetchListCtx({
                    lid: item.lid
                  },
                  (products) => {
                    if (products.length) {
                      const uniqueProducts = products.filter((e, i) => products.findIndex(a => a.epi === e.epi) === i)

                      uniqueProducts.forEach((product) => {
                        window._swat.getProductDetails(product, (resp) => {
                          resp.swym = product

                          resp.variants.forEach((variant) => {
                            if (variant.id === resp.swym.epi) {
                              resp.selected_variant = variant
                            }
                          })

                          const response = structuredClone(resp)
                          productsArray.push(response)
                        },
                        (err) => {
                          console.log(err)
                        })
                      })
                    }
                  },
                  (err) => {
                    console.log(err)
                  })

                  // You can't rely on sorting here because of swym api calls
                  this.data.push(productsArray)

                  // Share URLs
                  window._swat.generateSharedListURL(
                    item.lid,
                    (data, sharedListId) => {
                      if (data) {
                        const url = data.replace('swym-share-', '')

                        this.shareURLs.push({
                          lid: sharedListId,
                          url: url
                        })
                      }
                    },
                    (err) => {
                      console.log(err)
                    }
                  )
                })
              } else {
                this.loading = false
              }
            },
            errorFn: (err) => {
              console.log(err)
            }
          })
        })
      },
      klaviyoSignUp() {
        const subscribed = window.getCookie('footer_newsletter_subscribed')
        if (subscribed && subscribed === 'true') {
          this.subscribe.display = false
        }
      },
      listDetail(listId) {
        this.selected = listId
      },
      notifyModal(product, index) {
        const select = document.querySelector(`[data-size-select="${index}"]`) // Because $refs is too damn slow
        const variantId = parseInt(select.value)
        const variant = product.variants.find(variant => parseInt(variant.id) === variantId)

        this.notify.product = product
        this.notify.variant.id = variantId
        this.notify.variant.title = variant.title

        this.modal.notify = true
      },
      notifySend() {
        this.notify.message = ''

        BIS.create(this.user.from, this.notify.variant.id, this.notify.product.id)
          .then((resp) => {
            if (resp.status === 'OK') {
              this.notify.message = 'Success! We restock styles based on popular demand.'

              if (this.subscribe.display && this.subscribe.selected) {
                const email = this.user.from
                const listId = this.subscribe.listId
                const source = 'Wishlist Sign Up'

                window.klaviyoClientSubscription({ email, source, listId })
                  .then(() => {
                    Cookies.set('footer_newsletter_subscribed', 'true', { expires: 365, path: '/' })
                  })
                  .catch((error) => {
                    console.log(error)
                  })
              }
            } else {
              if (resp.errors.base) {
                this.notify.message = resp.errors.base[0]
              } else {
                this.notify.message = 'Sorry, something went wrong.'
              }
            }
          })
      },
      openMinicart() {
        const backdrop = document.querySelector('[data-sidebar-backdrop="cart"]')
        const html = document.querySelector('html')

        backdrop.classList.add('sidebar__backdrop--active')
        html.classList.add('sidebar-cart--active')
      },
      removeAll() {
        const i = Object.values(this.lists).findIndex(list => list.lid === this.selected)

        if (typeof this.data[i] !== 'undefined') {
          const icon = document.querySelector('[data-header-wishlist]')

          this.data[i].forEach((product, index) => {
            const listItemMap = {
              epi: product.swym.epi,
              empi: product.swym.empi,
              du: product.swym.du
            }
            window._swat.deleteFromList(this.selected, listItemMap, (response) => {})
          })

          if (icon.classList.contains('active')) {
            icon.classList.remove('active')
          }

          this.data[i] = []
          this.lists[i].listcontents = []
        }
      },
      removeItem(swymProduct, dataIndex, productIndex) {
        const listItemMap = {
          epi: swymProduct.epi,
          empi: swymProduct.empi,
          du: swymProduct.du
        }
        window._swat.deleteFromList(this.selected, listItemMap, (response) => {
          this.$delete(this.data[dataIndex], productIndex)
          this.$delete(this.lists[dataIndex].listcontents, productIndex)

          window.SwymCallbacks.push(() => {
            this.updateHeader()
          })
        })
      },
      removeList() {
        const i = Object.values(this.lists).findIndex(list => list.lid === this.selected)

        // Because the API is dumb and will keep the products if the list is deleted with an error
        if (typeof this.data[i] !== 'undefined') {
          this.data[i].forEach((product, index) => {
            const listItemMap = {
              epi: product.swym.epi,
              empi: product.swym.empi,
              du: product.swym.du
            }
            window._swat.deleteFromList(this.selected, listItemMap, (response) => {
              this.updateHeader()
            })
          })
        }

        window._swat.deleteList(this.selected, (response) => {
          this.modal.delete = false
          this.$delete(this.data, i)
          this.$delete(this.lists, i)
          this.selected = ''

          window.SwymCallbacks.push(() => {
            this.updateHeader()
          })
        }, (err) => {
          if (err === 500) {
            setTimeout(() => {
              this.removeList()
            }, 100)
          } else {
            console.log(err)
          }
        })
      },
      share() {
        window._swat.sendListViaEmail(
          {
            toEmailId: this.user.to,
            fromName: this.user.name,
            note: this.user.message,
            lid: this.selected,
            cprops: {}
          },
          (response) => {
            if (response && response.hasOwnProperty('msg')) {
              this.shareMessage = response.msg
            }
          },
          (err) => {
            this.shareMessage = err
          }
        )
      },
      sizeSelect(event, index, i) {
        const product = this.data[index][i]
        const selectedVariant = product.variants.find(v => v.id === parseInt(event.target.value))
        this.$set(this.data[index][i], 'selected_variant', selectedVariant)
      },
      updateHeader() {
        setTimeout(() => {
          window.SwymCallbacks.push(() => {
            window._swat.fetch((products) => {
              const count = document.querySelector('[data-header-wishlist-count]');
              const icon = document.querySelector('[data-header-wishlist]');
              const quantity = products.length;

              if (!this.wishlistInitialized) {
                let event = new CustomEvent('wishlist.initialized');
                document.dispatchEvent(event);
                this.wishlistInitialized = true;
              }

              if (quantity > 99) {
                count.classList.add('grande');
              } else {
                count.classList.remove('grande');
              }
              if (quantity) {
                icon.classList.add('active');
                count.textContent = quantity;
                count.setAttribute('data-header-wishlist-count', quantity);
              } else {
                if (icon.classList.contains('active')) {
                  icon.classList.remove('active');
                }
                count.setAttribute('data-header-wishlist-count', 0);
              }
            });
          });
        }, 500);
      },
      wishlistShare(lid) {
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = []
        }

        window.SwymCallbacks.push(() => {
          window._swat.fetchListDetails({
            lid: lid
          }, (response) => {
            if (response.hasOwnProperty('list')) {
              this.lists = []
              this.data = []
              this.lists.push(response.list)

              this.$nextTick(() => {
                this.selected = lid
                this.shareMode = true
                this.loading = false
              })

              this.lists.forEach((item, i) => {
                const productsArray = []

                window._swat.fetchListCtx({
                  lid: item.lid
                },
                (products) => {
                  if (products.length) {
                    const uniqueProducts = products.filter((e, i) => products.findIndex(a => a.epi === e.epi) === i)

                    uniqueProducts.forEach((product) => {
                      window._swat.getProductDetails(product, (resp) => {
                        resp.swym = product

                        resp.variants.forEach((variant) => {
                          if (variant.id === resp.swym.epi) {
                            resp.selected_variant = variant
                          }
                        })

                        const response = structuredClone(resp)
                        productsArray.push(response)
                      },
                      (err) => {
                        console.log(err)
                      })
                    })
                  }
                },
                (err) => {
                  console.log(err)
                })

                this.data.push(productsArray)
              })
            } else {
              this.loading = false
            }
          },
          (err) => {
            console.log(err)
          })
        })
      }
    },
    watch: {
      'modal.share': {
        handler: function(value) {
          if (!value) {
            this.shareURLactive = ''
          }
        },
        deep: true
      },
      selected() {
      }
    },
    created() {
      const params = new URLSearchParams(window.location.search)

      if (params.has('hkey') && params.has('lid')) {
        this.wishlistShare(params.get('lid'))
      } else {
        this.authCheck()
        this.fetchWishlists()
        this.klaviyoSignUp()
      }

      document.addEventListener('wishlist.updatelists', () => {
        this.fetchWishlists()
      })

      document.addEventListener('wishlist.error', () => {
        this.fetchWishlists()
        this.updateHeader()

        window.SwymCallbacks.push(() => {
          window._swat.fetch((products) => {
            const variants = []
            products.forEach((product) => {
              variants.push(product.empi)
            });
            if (document.querySelector('[data-quick-shop] [data-wishlist-button]')) {
              const quickshops = document.querySelectorAll('[data-quick-shop]');
              quickshops.forEach((quickshop) => {
                const wishExists = quickshop.querySelectorAll('.wish-exists');
                const quickshopProducts = quickshop.querySelectorAll('[data-wishlist-button]');
                wishExists.forEach((wishExist) => {
                  wishExist.classList.remove('wish-exists');
                });
                quickshopProducts.forEach((quickshopProduct) => {
                  const pId = parseInt(quickshopProduct.getAttribute('data-wishlist-button'));
                  const container = quickshopProduct.closest('[data-quick-shop-item]');
                  if (variants.includes(pId)) {
                    container.classList.add('wish-exists');
                  }
                });
              });
            }
          });
        });
      })
    },
    mounted() {
      this.events()
    }
  })
}

const interval = setInterval(() => {
  if (typeof Vue === 'function') {
    wishlistPageInit()
    clearInterval(interval)
  }
}, 50)